<template>
  <div>
    <div class="columns is-multiline is-mobile">
      <div class="column is-half-mobile is-one-quarter-tablet" v-for="(recipe, index) in recipes" :key="index">
        <recipe-preview :recipe="recipe"/>
      </div>
    </div>
    <infinite-loading :distance="400" @infinite="loadNextPage">
      <loading-indicator size="is-large" slot="spinner"/>
      <span slot="no-more"/>
      <span slot="no-results"/>
    </infinite-loading>
  </div>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import LoadingIndicator from 'shared/components/LoadingIndicator.vue'
import RecipePreview from './Preview.vue'

export default {
  props: {
    endpoint: { type: String, default: () => window.__INIT_DATA.endpoint },
    lang: { type: String, default: () => window.__INIT_DATA.lang }
  },

  components: {
    InfiniteLoading,
    LoadingIndicator,
    RecipePreview
  },

  data(){
    return {
      recipes: this.getRecipes(window.__INIT_DATA),
      totalCount: this.getTotalCount(window.__INIT_DATA),
      page: window.__INIT_DATA.page || 1,
      loading: false
    }
  },

  methods: {
    loadNextPage($state) {
      if(this.loading) return
      if(this.totalCount < 32) return $state.complete()

      this.page++
      this.loading = true

      return axios.get(this.endpointUrl())
      .then(result => {
        const recipes = this.getRecipes(result.data)
        this.recipes = this.recipes.concat(recipes)
        this.totalCount = this.getTotalCount(result.data)
        this.page = result.data.page
        this.loading = false

        if(this.totalCount <= this.recipes.length || recipes.length === 0) $state.complete()
        else $state.loaded()
      })
    },


    endpointUrl(){
      if(window.__INIT_DATA.id) return `/${this.lang}/${this.endpoint}/${window.__INIT_DATA.id}/${this.page}.json${window.location.search}`
      return `/${this.lang}/${this.endpoint}/${this.page}.json${window.location.search}`
    },

    getRecipes(data){
      if(data.recipes) return data.recipes.nodes
      if(data.category) return data.category.all_recipes.nodes
      return []
    },

    getTotalCount(data){
      if(data.recipes) return data.recipes.totalCount
      return Infinity
    }
  }
}
</script>

<style>
  .infinite-loading-container{
    width: 100%;
    margin-top: 4em;
  }
</style>



// WEBPACK FOOTER //
// src/components/recipe/List.vue